import { useMsal } from "@azure/msal-react";
import {
  AccountCircleOutlined,
  Brightness4,
  Brightness7,
} from "@mui/icons-material";
import {
  AppBar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleTheme } from "../../redux/actions/commonAction";
import storage from "../../utils/storage";

const Header = ({ open }) => {
  const classes = useStyles();
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const { themeType } = useSelector((state) => state.common);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleLogout = () => {
    storage.clear();
    setAnchorEl(null);
    instance.logoutRedirect()
  };

  return (
    <AppBar
      sx={{
        minHeight: (theme) => theme.spacing(6.5),
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        color: "unset",
        backgroundColor: (theme) => theme.palette.background.default,
      }}
      position="fixed"
      open={open}
    >
      <Box className={classes.iconView}>
        <Tooltip title={themeType === "light" ? "Dark Mode" : "Light Mode"}>
          <IconButton
            size="small"
            onClick={() =>
              dispatch(toggleTheme(themeType === "light" ? "dark" : "light"))
            }
          >
            {themeType === "light" ? <Brightness4 /> : <Brightness7 />}
          </IconButton>
        </Tooltip>
        <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
          <AccountCircleOutlined />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          keepMounted
          transformOrigin={{ vertical: "bottom", horizontal: "right" }}
          onClose={() => setAnchorEl(null)}
        >
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Box>
    </AppBar>
  );
};

export default Header;

const useStyles = makeStyles((theme) => {
  return {
    iconView: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      padding: theme.spacing(0, 1),
      background: theme.palette.background.white,
      borderRadius: "24px",
      marginRight: theme.spacing(5),
      border: `1px solid ${theme.palette.grey[500]}`,
    },
  };
});
